
export function login(fetch, dados) {
  return fetch().post("auth/login", dados);
}

export function register(fetch, dados, versao) {
  return fetch(versao).post("auth/register", dados);
}

export function atualizarDados(fetch) {
  return fetch().post("integracao/atualizar");
}